import { Controller, useFormContext } from 'react-hook-form'

import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

const EMPTY_OPTION = { label: 'Not selected', value: '' }

type CorroborativeStatementToFilerProps = {
  index: number
}

export const CorroborativeStatementToFiler = ({ index }: CorroborativeStatementToFilerProps) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`subjectsInfo.${index as 0}.corroborativeStatementToFiler`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="23. Corroborative statement to filer?"
          input={(props) => (
            <Select
              {...props}
              data={[
                { label: 'Yes', value: 'Yes' },
                { label: 'No', value: 'No' }
              ]}
              emptyOption={EMPTY_OPTION}
            />
          )}
        />
      )}
    />
  )
}
